import { useHiringFlows } from "@/queries/use-hiring-flows.query";
import { Button, DropdownMenu, DropdownMenuItem, FontAwesomeIcon } from "@skailer-com/uikit";
import { ComponentProps, useState } from "react";
import { useTranslation } from "react-i18next";

export function HireFlowMenuItems({
  candidateId,
  target,
  enabled = true,
}: {
  candidateId?: number;
  target?: "_self" | "_blank";
  enabled?: boolean;
}) {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useHiringFlows(enabled);
  if (isLoading) return <DropdownMenuItem title={t("common:loading")} disabled />;
  if (isError || !data?.length)
    return <DropdownMenuItem title={t("hiring_flow:not_found")} disabled />;
  return (
    <>
      {data.map((flow) => (
        <DropdownMenuItem
          key={flow.id}
          title={flow.title}
          target={target}
          to={`/employees/hire?hiring_flow_id=${flow.id}${candidateId ? `&candidate_id=${candidateId}` : ""}`}
        />
      ))}
    </>
  );
}

export function HireFlowButton({
  title,
  candidateId,
  variant = "primary",
  leftIcon,
}: {
  title: string;
  candidateId?: number;
  variant?: ComponentProps<typeof Button>["variant"];
  leftIcon?: ComponentProps<typeof Button>["leftIcon"];
}) {
  const [open, setOpen] = useState(false);
  return (
    <DropdownMenu
      open={open}
      onOpenChange={setOpen}
      trigger={
        <Button
          variant={variant}
          leftIcon={leftIcon}
          rightIcon={<FontAwesomeIcon icon="fa-light fa-chevron-down" />}
        >
          {title}
        </Button>
      }
    >
      <HireFlowMenuItems candidateId={candidateId} enabled={open} />
    </DropdownMenu>
  );
}
